import React from "react";
import { PageMessage } from "@picklebet/ui";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";
import { useIsMobile } from "@/hooks/useDisplay";
import { ReactComponent as WarningPending } from "assets/illustrations/warning-pending.svg";

const WithdrawVerificationRequired = () => {
  const isMobile = useIsMobile();

  return (
    <PageMessage
      image={<WarningPending />}
      title="Verification Required"
      subTitle="You need to verify your account to withdraw."
    >
      <LinkButton
        variant="primary"
        size={isMobile ? "md" : "default"}
        to="/account/verification"
      >
        Verify
      </LinkButton>
    </PageMessage>
  );
};

export { WithdrawVerificationRequired };
